import React from "react";
import { Modal } from "react-bootstrap";
import Button from "rsuite/esm/Button";

const ConfirmationModal = ({ title, text, onConfirm, showModal, setShowModal }) => {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <Modal show={showModal} onHide={() => closeModal(null)} className="confirm-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{text}</Modal.Body>

      <Modal.Footer style={{display: "flex", gap: "10px", justifyContent: "flex-end"}}>
        <Button appearance="primary" onClick={() => onConfirm()}>
          Confirm
        </Button>

        <Button
          className="btn-dark-btn btn btn-dark"
          onClick={() => closeModal(null)}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/ConfirmationModal.js